import React from "react";
import { FaFacebookF, FaLinkedin } from "react-icons/fa";
import { BiVideo, BiLinkAlt } from "react-icons/bi";
import { DiGithubAlt } from "react-icons/di";
const SideBar = ({ title, infos, subTitle, links, bgPr, setVideoModal }) => {
  return (
    <aside className=" flex flex-col gap-8 md:gap-12 lg:gap-16">
      <div
        className={`${
          bgPr ? "bg-prColor/80" : "bg-scColor/80"
        } flex-grow  px-4 xs:px-8 py-8 xs:py-12 shadow shadow-borderColor`}
      >
        {title && (
          <h3 className="text-xl sm:text-2xl md:text-3xl text-light font-semibold font-['Merriweather'] mb-6">
            {title}
          </h3>
        )}
        <div className="flex flex-col md:flex-row lg:flex-col gap-6">
          {infos.map((info, i) => {
            return (
              <div
                className={`flex-grow font-['Poppins'] ${
                  bgPr
                    ? "bg-scColor/90 hover:bg-prColor/90"
                    : "bg-prColor/90 hover:bg-scColor/90"
                }  outline-none hover:outline hover:outline-1 hover:outline-dark transition-all duration-500 p-8`}
                key={i}
              >
                <h4 className="text-light font-bold text-sm sm:text-lg tracking-wider mb-3">
                  {info.title}
                </h4>
                <p className="text-dark text-sm sm:text-lg">{info.details}</p>
              </div>
            );
          })}
        </div>
      </div>
      {subTitle && links && (
        <div
          className={`${
            bgPr ? "bg-prColor/80" : "bg-scColor/80"
          } flex flex-col gap-6 px-6 xs:px-12 py-12 xs:py-16 shadow shadow-borderColor`}
        >
          <h3 className="text-2xl sm:text-3xl md:text-4xl text-light font-semibold font-['Merriweather']">
            {subTitle}
          </h3>
          <div className="flex gap-4 flex-wrap mt-4">
            {links.map((link, i) => (
              <a
                href={link.url}
                className="social-icon"
                rel="noreferrer"
                key={i}
                onClick={(e) => {
                  console.log(e.currentTarget.href);
                  if (e.target.href === "javascript:void(0)") {
                    setVideoModal({ isOpen: true });
                  }
                }}
              >
                {getIcon(link.icon)}
              </a>
            ))}
          </div>
        </div>
      )}
    </aside>
  );
};
const getIcon = (icon) => {
  switch (icon) {
    case "fb":
      return <FaFacebookF className="text-lg" />;
    case "linkedIn":
      return <FaLinkedin className="text-lg" />;
    case "live":
      return <BiLinkAlt className="text-xl" title="Go Live" />;
    case "github":
      return <DiGithubAlt className="text-xl" title="See Code" />;
    case "video":
      return <BiVideo className="text-xl" title="See Video" />;
    default:
      return "";
  }
};
export default SideBar;
